/**
    商品列表
**/
<template>
  <div style="width: 1200px; margin: auto">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商家入驻申请</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="20">
      <el-col :span="7">
        <div class="leftaside">
          <h4>商家入驻指南</h4>
          <div class="left_product">
            <el-menu
              default-active="2"
              class="el-menu-vertical-demo"
              :unique-opened='true'
              background-color="#f7f8f8"
            >
              <el-submenu index="1">
                <template slot="title">入驻流程</template>
                <el-menu-item index="0-1">商家提交申请</el-menu-item>
                <el-menu-item index="0-2">平台审核资质</el-menu-item>
                <el-menu-item index="0-3">商家缴纳费用</el-menu-item>
                <el-menu-item index="0-4">店铺开通</el-menu-item>
              </el-submenu>
              <el-menu-item index="2">
                <template slot="title"
                  >签订入驻协议</template
                >
              </el-menu-item>
              <el-menu-item index="3">
                <template slot="title"
                  >选择店铺类型</template
                >
              </el-menu-item>
              <el-menu-item index="4">
                <template slot="title"
                  >平台审核</template
                >
              </el-menu-item>
              <el-menu-item index="5">
                <template slot="title"
                  >合同签订及缴费</template
                >
              </el-menu-item>
              <el-menu-item index="6">
                <template slot="title"
                  >店铺开通</template
                >
              </el-menu-item>
            </el-menu>
          </div>
        </div>
        <div class="leftaside">
          <h4>平台联系方式</h4>
          <div class="left_product" style="padding: 20px">
             <p>电话： 400-011-9000</p>
            <p>邮箱：wangxiaolong@gsafety.com</p>
          </div>
        </div>
      </el-col>
      <el-col :span="17" class="rightaside">
        <div>
          <h3>入驻协议</h3>
          <el-divider></el-divider>
          <div v-html="agreementContents"></div>
          <!-- <p>
            使用本公司服务所须遵守的条款和条件。 1.用户资格
            本公司的服务仅向适用法律下能够签订具有法律约束力的合同的个人提供并仅由其使用。在不限制前述规定的前提下，本公司的服务不向18周岁以下或被临时或无限期中止的用户提供。如您不合资格，请勿使用本公司的服务。此外，您的账户（包括信用评价）和用户名不得向其他方转让或出售。另外，本公司保留根据其意愿中止或终止您的账户的权利。
            2.您的资料（包括但不限于所添加的任何商品）不得：
            *具有欺诈性、虚假、不准确或具误导性；
            *侵犯任何第三方著作权、专利权、商标权、商业秘密或其他专有权利或发表权或隐私权；
            *违反任何适用的法律或法规（包括但不限于有关出口管制、消费者保护、不正当竞争、刑法、反歧视或贸易惯例/公平贸易法律的法律或法规）；
            *有侮辱或者诽谤他人，侵害他人合法权益的内容；
            *有淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的内容；
            *包含可能破坏、改变、删除、不利影响、秘密截取、未经授权而接触或征用任何系统、数据或个人资料的任何病毒、特洛依木马、蠕虫、定时炸弹、删除蝇、复活节彩蛋、间谍软件或其他电脑程序；
            3.违约
            如发生以下情形，本公司可能限制您的活动、立即删除您的商品、向本公司社区发出有关您的行为的警告、发出警告通知、暂时中止、无限期地中止或终止您的用户资格及拒绝向您提供服务：
            (a)您违反本协议或纳入本协议的文件；
            (b)本公司无法核证或验证您向本公司提供的任何资料；
            (c)本公司相信您的行为可能对您、本公司用户或本公司造成损失或法律责任。
            4.责任限制
            本公司、本公司的关联公司和相关实体或本公司的供应商在任何情况下均不就因本公司的网站、本公司的服务或本协议而产生或与之有关的利润损失或任何特别、间接或后果性的损害（无论以何种方式产生，包括疏忽）承担任何责任。您同意您就您自身行为之合法性单独承担责任。您同意，本公司和本公司的所有关联公司和相关实体对本公司用户的行为的合法性及产生的任何结果不承担责任。
            5.无代理关系
            用户和本公司是独立的合同方，本协议无意建立也没有创立任何代理、合伙、合营、雇员与雇主或特许经营关系。本公司也不对任何用户及其网上交易行为做出明示或默许的推荐、承诺或担保。
            6.一般规定
            本协议在所有方面均受中华人民共和国法律管辖。本协议的规定是可分割的，如本协议任何规定被裁定为无效或不可执行，该规定可被删除而其余条款应予以执行。
          </p> -->
          <el-form :rules="rules" ref="sizeForm" :model="sizeForm" size="mini" class="nextPart">
            <el-form-item prop="checkedBox">
                <el-checkbox v-model="sizeForm.checkedBox">我已阅读并同意以上协议</el-checkbox>
                <span v-show="errerInfo" style="color:#f42424;margin-left:15px">请勾选 </span>
            </el-form-item>
             <el-form-item>
                <el-button class="nextButtom" type="primary" @click="nextEditResource('ruleForm')">下一步,填写资料</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {agreementContent} from "@/api/xunyou";
export default {
  data() {
    return {
      type:'',
        agreementContents:'',
        errerInfo:false,
        sizeForm:{
            checkedBox:false,            
        },
        rules: {
        //   checkedBox: [
        //     { required: true, message: 'c', trigger: ['blur', 'change'] }
        //   ]
        }
        
    };
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
   this.type = this.$route.query.type;
  },
  mounted(){
    this.getAgreementContent()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取协议内容
     getAgreementContent() {
            agreementContent()
              .then((res) => {
               
                  if (res.code == 0) {
                    console.log(res.rows,"rows");
                    res.rows.map(item=>{
                      // console.log(item,"item");
                      // 1-供应商，3-采购商 
                      if(this.type==item.type)
                    return   this.agreementContents=item.work
                     
                     })
                  
                }
              })
              .catch((err) => {
                this.$message.error("查询协议内容失败，请稍后再试！");
              });
          },

   nextEditResource(){
       this.$refs.sizeForm.validate((valid) => {
          if (valid) {
            if(this.sizeForm.checkedBox){
                this.errerInfo=false;
                this.$router.push(`/merchantForm?type=${this.$route.query.type||2}`) // 2为普通店铺
            }else{
                this.errerInfo=true;
            }
          }
        });
   }
  },
};
</script>

<style scoped lang="less">
.breakcrumbHeader {
  margin: 15px 0;
}
.leftaside {
  width: 300px;
  box-sizing: border-box;
  font-size: 14px;
  border: 1px solid #ddd;
  margin-right: 10px;
  margin-bottom: 40px;
  .el-submenu .el-menu-item {
    height: 25px;
    line-height: 25px;
  }
  /deep/.el-submenu__title,.el-menu-item {
    height: 40px;
    line-height: 40px;
  }
  /deep/.el-submenu__title:focus,
  /deep/.el-submenu__title:hover,
  /deep/.el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow,
  /deep/.el-menu-item.is-active {
    color: #f42424;
  }  
}
.leftaside h4 {
  padding: 10px;
  border-bottom: 1px solid #ddd;
  font-size: 16px;
  font-weight: 700;
}

.rightaside{
    h3{
      font-size: 18px; 
      color: #333;
    }
    .nextPart{
      margin-top:20px;
    }
    .nextButtom{
        background: #ff6700;
        border: 1px solid #ff6700;
    }
}

</style>

 
 

 


// WEBPACK FOOTER //
// src/views/merchantSettled/merchantApply.vue